module.exports = __webpack_public_path__ + "img/download-apk-pc.87223d1.png";